export const favoriteMetadata = {
  "title-ar": "قائمة المفضلات: أفضل الأجهزة والإلكترونيات والعروض | المنيع",
  "title-en": "Your Favorites: Appliances & Electronics Deals | Almanea",
  "description-ar":
    "تسوق منتجاتك المفضلة في المنيع السعودية. اكتشف أفضل الأجهزة والإلكترونيات، وادِر قائمة المفضلات بسهولة. توصيل سريع وشحن مجاني للطلبات فوق 299 ريال.",
  "description-en":
    "Buy your favorite items online at Almanea KSA. Find top-rated appliances and electronics, manage your wishlist easily, and enjoy fast delivery with free shipping on orders over SAR 299.",
};
export const favoriteMetadata2 = {
  'title-ar':'',
  'title-en': '',
  'description-ar':'',
  'description-en':''
}